<template>
    <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                {{Core.Definition.getDefinition('Formulaire')}}
            </div>

            <b-row>
                <b-col>
                    <DynamicForm
                            v-if="Core.Validation.isId(dataFormTemplateId)||Core.Validation.isId(dataId)"
                            v-model="dataId"
                            ref="dynamicForm"
                            :options="{}"
                            getRoot="/form"
                            @onInit="onInit"
                            :formStructure="dataFormStructure">
                    </DynamicForm>
                </b-col>
            </b-row>
        </b-card>

        <ModalTrash
                ref="trash"
                root="/form"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'entrée')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette entrée?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    import Request from '../../components/Request'
    export default {
        name: 'Form',
        components: {
            DynamicForm,
            ModalTrash,
            Request
        },
        mounted() {
            if (Core.Validation.isId(this.$route.params.formTemplateId)) {
                this.dataFormTemplateId = this.$route.params.formTemplateId
            }
            if (Core.Validation.isId(this.$route.params.id)) {
                this.dataId = this.$route.params.id
            }
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructure: {},
                dataFormTemplateId: ''
            }
        },
        methods: {
            onInit() {
                this.$refs.dynamicForm.$refs.request.addArg('formTemplateId', this.dataFormTemplateId)
            },
            onSave() {
                this.$refs.dynamicForm.$refs.request.addArg('formTemplateId', this.dataFormTemplateId)
            },
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/formulaire/entrees')
            }
        }
    }
</script>
